import { useEffect, useState } from "react";
import Table from "../ScheduleManagement/Table";
import styles from "./ScheduleManagement.module.css";
import { fetchAppointments } from "../../../utils/apis.utils";
import { fetchAppointment } from "../../../utils/global.apis";
import moment from "moment";


const AppointmentManagement = (props)=>{

    const [data,setData]=useState([
        ["Name",'Phone',"Email","Date","Time"],
        ["Ashish",'1234567890',"healinroots@gmail.com","10-10-2023","10:00-12:00"],
    ]);

    useEffect(()=>{fetchAllApointment()},[])

    // const fetchAllApointment = async () => {
    //     const response = await fetchAppointment()
    //     console.log("check",response.data.data)
    //     let tempData = [["Name",'Phone',"Email","Date","Time"]]
    //     response.data.data.map(el=>{
    //         // console.log(el)
    //         let phone = el.user.isParent ? el?.user?.phone : el?.user?.parent?.phone
    //         let email = el.user.isParent ? el?.user?.email : el?.user?.parent?.email
    //         tempData.push([el.user.name, phone, email, moment(el.date).format("DD-MM-YYYY"),`${el.from}-${el.to}`])
    //     })
    //     setData(tempData)
    // }
    const fetchAllApointment = async () => {
        try {
            const response = await fetchAppointment();
            let tempData = [["Name", 'Phone', "Email", "Date", "Time"]];
            response.data.data.forEach(el => {
                if (el.user) {
                    let phone = el.user.isParent ? el?.user?.phone : el?.user?.parent?.phone;
                    let email = el.user.isParent ? el?.user?.email : el?.user?.parent?.email;
                    tempData.push([
                        el.user.name || "N/A",
                        phone || "N/A",
                        email || "N/A",
                        moment(el.date).format("DD-MM-YYYY") || "N/A",
                        `${el.from || "N/A"} - ${el.to || "N/A"}`
                    ]);
                } else {
                    console.warn("User data is null for an entry", el);
                }
            });
            setData(tempData);
        } catch (error) {
            console.error("Error fetching appointments:", error);
        }
    };

    return <div className={styles["container"]}>
        <div className={styles["content"]}>
            <div className={styles["headings"]}>
                <h1>Appointment management</h1>
            </div>
            <div className={styles["table"]}>
                <div className={styles["tab"]}>
                    <Table data={data} makeLastBtn={false}/>
                </div>
            </div>
        </div>
    </div>;
}

export default AppointmentManagement;